$(function(){
  guide();
});
window.addEventListener('hashchange', guide, false);


function guide(){
  var hash = location.hash;
  var splitHash = hash.split('#');
  var key = splitHash[1];
  $('.guide_content_inner').hide();
  if (hash != "") {
    $('.guide_content_inner').each(function(){
      var gc = $(this).data('cn');
      if (gc == key) {
        var cn = $(this).data('cn');
        var gn = $(this).data('gn');
        $(this).show();
        $('.outer_list>li').each(function(){
          var mgn = $(this).data('mgn');
          if (mgn == gn) {
            $(this).find('.inner_list').show();
            $(this).addClass('open');
          }else{
            $(this).find('.inner_list').hide();
            $(this).removeClass('open');
          }
        });
        $('.outer_list .inner_list>li').each(function(){
          var label = $(this).data('label');
          if (label == cn) {
            $(this).addClass('active');
          }else{
            $(this).removeClass('active');
          }
        });
        $(window).scrollTop(0);
      }
    });
  }

}



$(function(){
  $('.outer_list>li>a').click(function(){
    $(this).parent().find('.inner_list').slideToggle(200);
    $(this).parent().toggleClass('open');
  });
});


$(function(){
  $("#word").keydown(function() {
    if( event.keyCode == 13 ) {
      searchGuide();
      $("#word").blur();
      return false;
    }
  });
  $('#searchbtn').click(function(){
    searchGuide();
  });

  var para = location.search;
  var word = para.slice(1);
  var search = decodeURI(word);

  $('.guide_content_child').each(function(){
    if ( $(this).children().is(":contains('"+search+"')") ) {
      var num = $(this).data('cn');
      $('.guide_menu_block .outer_list li').each(function(){
        if ($(this).data('label')==num) {
          var listTitle = $(this).html();
          $('.guide_search_result .inner_list').append('<li>'+listTitle+'</li>');
        }
      });

      $(this).addClass('include');
    }
  });

  if (search) {
    $('.show_search_word').append(search);
    if (location.hash.length) {
      $('.guide_search_result').hide();
    }else{
      $('.guide_search_result').show();
    }
    if (!($('.guide_search_result .inner_list li').length)) {
      $('.guide_search_result').append('<p>検索ワードを含む項目はありません。</p>')
    }
  }

});


function searchGuide(){
  var searchword = $('#word').val();
  window.location.href = '/pages/shopping-guide?'+searchword;
}
